<div class="specific-container">
    <div class="entity-name overflow-ellipsis">{{ item.result.name }}</div>
    <div class="entity-trigram">
        <div *ngIf="item.result.entityShortId; then entityShortId; else warning"></div>
        <ng-template #entityShortId>
            {{ item.result.entityShortId }}
        </ng-template>
        <ng-template #warning>
            <aa-icon-circle class="danger duotone" [faIcon]="'fas fa-exclamation'" title="The entity has no short id">
            </aa-icon-circle>
        </ng-template>
    </div>
</div>
